export default "__VITE_ASSET__DmLWt3md__"